class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.handleTriggerClick = this.handleTriggerClick.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
    this.handleOverlayClick = this.handleOverlayClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    this.modalId = this.dataset.modalId;
    this.panel = this.querySelector('[data-modal-panel]');
    this.overlay = this.querySelector('[data-modal-overlay]');
    this.closeButtons = this.querySelectorAll('[data-modal-close]');
    this.triggers = document.querySelectorAll(`[data-modal-trigger="${this.modalId}"]`);
    console.log("init modal")
    console.log(this)
    console.log(this.triggers)
    if (!this.modalId || !this.panel) return;

    this.syncTriggers();

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', this.handleTriggerClick);
    });

    this.closeButtons.forEach((button) => {
      button.addEventListener('click', this.handleCloseClick);
    });

    this.overlay?.addEventListener('click', this.handleOverlayClick);
  }

  disconnectedCallback() {
    this.triggers?.forEach((trigger) => {
      trigger.removeEventListener('click', this.handleTriggerClick);
    });

    this.closeButtons?.forEach((button) => {
      button.removeEventListener('click', this.handleCloseClick);
    });

    this.overlay?.removeEventListener('click', this.handleOverlayClick);

    document.removeEventListener('keydown', this.handleKeydown);
  }

  syncTriggers() {
    this.triggers.forEach((trigger) => {
      trigger.setAttribute('aria-controls', this.modalId);
      trigger.setAttribute('aria-expanded', this.dataset.open === 'true' ? 'true' : 'false');
    });
  }

  handleTriggerClick(event) {
    event.preventDefault();
    this.open(event.currentTarget);
  }

  handleCloseClick(event) {
    event.preventDefault();
    this.close();
  }

  handleOverlayClick(event) {
    event.preventDefault();
    this.close();
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }

  open(trigger) {
    const activeModal = document.querySelector('modal-dialog[data-open="true"]');
    if (activeModal && activeModal !== this) {
      activeModal.close();
    }

    this.syncTriggers();
    this.lastTrigger = trigger || document.activeElement;
    this.dataset.open = 'true';
    this.hidden = false;

    document.body.classList.add('overflow-hidden');
    document.addEventListener('keydown', this.handleKeydown);

    this.triggers.forEach((modalTrigger) => {
      modalTrigger.setAttribute('aria-expanded', 'true');
    });

    window.requestAnimationFrame(() => {
      this.overlay?.classList.remove('opacity-0');
      this.panel.classList.remove('opacity-0', 'translate-y-4');
      this.panel.focus();
    });
  }

  close() {
    this.dataset.open = 'false';
    this.overlay?.classList.add('opacity-0');
    this.panel?.classList.add('opacity-0', 'translate-y-4');

    document.body.classList.remove('overflow-hidden');
    document.removeEventListener('keydown', this.handleKeydown);

    this.syncTriggers();
    this.triggers.forEach((modalTrigger) => {
      modalTrigger.setAttribute('aria-expanded', 'false');
    });

    window.setTimeout(() => {
      this.hidden = true;
    }, 200);

    if (this.lastTrigger instanceof HTMLElement) {
      this.lastTrigger.focus();
    }
  }
}

const registerModalDialog = () => {
  if (!customElements.get('modal-dialog')) {
    customElements.define('modal-dialog', ModalDialog);
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', registerModalDialog, { once: true });
} else {
  registerModalDialog();
}
